import React, {Component} from 'react';
import GroupCardTopic from './GroupCardTopic.js';
import './card.css';
import right_arrow from '../../wb/right_pg_arrow.gif';
import left_arrow from '../../wb/left_pg_arrow.gif';
import list_view_button from '../../wb/cube_list.jpg';

class Card extends Component  {
    constructor (props) {
        super(props);
        this.displayGroup = this.displayGroup.bind(this);
        this.getTopics = this.getTopics.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.handlePageDown = this.handlePageDown.bind(this);
        this.handlePageUp = this.handlePageUp.bind(this);
        this.handleGroupLineNameClick = this.handleGroupLineNameClick.bind(this);
        this.handleGroupDisplayClick = this.handleGroupDisplayClick.bind(this);
        
        this.state ={
            topics:[],      // set of topics for display group
            blurbs: {},      // topic id key and wikipedia blurb and url
            image_urls: {},
            display:'group', // group or single
            topic: {},  // topic for single display view
            pg: 1,         // parameter to daypage.php 
            pgsize: 5,     // parameter to daypage.php, TBD: remove use single/group for size
            group_size: 5, // const for fetching topics
            total: 0
        };
    }

    getSingleTopic (page) {
        // if page is in current group then index topic and fetch blurb
        let foundTopic = false;
        let group = Math.floor((this.state.pg-1)/this.state.group_size) + 1;
        let next_group = Math.floor((page-1)/this.state.group_size) + 1
        
        if (group === next_group) {
            // Remainder maps to the index of the topic in the current set
            let i = (page-1) % this.state.group_size; 
            this.setState({
                topic: this.state.topics[i],
                pg: page
            })
            this.getTopicBlurb(this.state.topics[i]);
            foundTopic = true;
        }
        return foundTopic;
    }


    getTopics (page=1) {
        /*
        daypage.php params 
            &day=06-26 &year= &pg=1 &pgsize=5 &types= &domains= &pv= &sort= &stats=no        
        */

        let next_group = page; 
        if (this.state.display === 'single') {
            // if single topic is in current group then 
            // getSingleTopic will use topics index to fetch blurb
            // otherwise continue to fetch a new group of topics, then fetch blurb

            next_group = Math.floor((page-1)/this.state.group_size) + 1;
            if (this.getSingleTopic(page)) {
                return;
            }
        }

        // Ensure day is in correct mm-dd format for daypage.php
        // TBD: Server should handled various formats.
        const d = new Date(this.props.day)
        const day = (d.getMonth()+1).toString().padStart(2, '0')
                    +'-'+d.getDate().toString().padStart(2, '0');
        // const wb_data_url = 'http://localhost/wb/daypage.php';
        // const wb_data_url = 'http://localhost:3000/daypage.php';
        const wb_data_url = 'http://wiggleback.com/daypage.php';
        // const wb_data_url = 'http://testcycle.com/daypage.php';

        let topics_url = 
            `${wb_data_url}?day=${day}${this.props.filter}&pgsize=${this.state.group_size}`;
        topics_url += '&pg='+ next_group;
        
        // TBD: handle origin, had to set daypage.php to allow origin localhost:3000
        fetch(topics_url) // ,{mode: 'no-cors'}
        .then(response => response.json())
        .then(response => {         
            this.setState({
                topics:response.result,
                pg: page,    
                total: Number(response.count) 
            })
            response.result.forEach(t => {
                this.getTopicImageURL(t);
            });

            if (this.state.display === 'single') {
                this.getSingleTopic(page);
            }

            
         });
    }


    getTopicImageURL(topic, maxwidth=90){
        
        // don't need to fetch if state is set
        if ((topic.id in this.state.image_urls)) {
            return;
        }
        let wp_api = '';
        if (typeof topic === 'object') {	    
            if ('wp_key' in topic) {
                wp_api += 'https://en.wikipedia.org/w/api.php?'; 
                wp_api += 'format=json&action=query&prop=pageimages&piprop=thumbnail';
                wp_api += '&pithumbsize=' + maxwidth;
                wp_api += '&pageids=' +topic['wp_key'];
                wp_api += '&origin=*'; // required for no-cors
            }
            
        }
        
        if (wp_api) {
            let wp_url = 'none';
            fetch(wp_api) //,{mode: 'no-cors'}
            .then(response => response.json())
            .then(response => {
                if (response.batchcomplete !== undefined && response.query !== undefined &&
                    response.query.pages !== undefined && 
                    response.query.pages[topic['wp_key']].thumbnail !== undefined  &&
                    response.query.pages[topic['wp_key']].thumbnail.source !== undefined  
                    ) 
                {
                    wp_url = response.query.pages[topic['wp_key']].thumbnail.source
                }
                let image_urls = Object.assign(this.state.image_urls);;
                image_urls[topic.id] = wp_url;
                // TBD: Handle multiple image sizes
                // single display uses 70,90
                this.setState({image_urls:image_urls})
             })
             .catch( (e) => {
                console.log('WP fetch error',e);
             });		
        }
        
    } // getTopicImageURL

    componentDidMount () {
        this.getTopics();
    };

    componentDidUpdate(prevProps) {
        if (this.props.day !== prevProps.day ||
            this.props.title !== prevProps.title||
            this.props.filter !== prevProps.filter) {
          this.getTopics();
        }
      }

    getTopicBlurb (topic, max) {
        // TBD: decide whether to have default max=550;

        let blurburl = 'https://en.wikipedia.org/w/api.php?'; 
        blurburl += 'format=json&action=query&prop=extracts&exintro&explaintext&redirects=1';
        blurburl += '&origin=*'; // required for no-cors
        if (max) {
            blurburl += "&exchars=" + max;
        }

        if ('wp_key' in topic) {
            blurburl += '&pageids=' +topic['wp_key'];
        }        
    
        if (blurburl) {
            let blurb = '';
            fetch(blurburl)
            .then(response => response.json())
            .then(response => {
                if (response.batchcomplete !== undefined && response.query !== undefined &&
                    response.query.pages !== undefined && 
                    response.query.pages[topic['wp_key']].extract !== undefined
                    ) 
                {
                    blurb = response.query.pages[topic['wp_key']].extract
                }
                // Have to copy state to update then replace state value
                // TBD: refactor to be more efficient
                let blurbs = Object.assign(this.state.blurbs);
                blurbs[topic.id] = {text: blurb};   
                this.setState({blurbs: blurbs});
                
            })
             .catch( (e) => {
                console.log('WP text fetch error',e);
             });
        }
    }
    handleGroupDisplayClick () {
        let group = Math.floor((this.state.pg-1)/this.state.group_size) + 1;
        
        this.setState({
            pgsize: this.state.group_size,
            pg: group,
            display: 'group'
        });
    }


    handleGroupLineNameClick (topic) {
        
        // Clicking on name changes view to single topic with text summary (blurb)
        // get index of topic for card nav
        // pg# * pgsize = last in group
        // traverse to get specific topic number
        // set pg  to topic number, pgsize to 1

        let i = 0; 
        while (this.state.topics[i].id !== topic.id && i < this.state.topics.length) 
            {
                i++;
            }
        
        // Set pg # corresponding to location of single topic page, 
        // the topic index of the full set which is not loaded (fetches in groups of 5)
        // Examples:
        // first topic first page: 5*1 = 5 - (4-0) = 1
        // first topic second page 5*2 = 10 - (4-0) = 6
        // last topic second page 10 - (4-4) = 10
        // 2nd topic second page 10 - (4-1) = 7
        const pg = (this.state.pgsize * this.state.pg) - ((this.state.pgsize - 1) - i);

        this.setState({
            topic: topic,
            pgsize: 1,
            pg: pg,
            display: 'single'
        });
        
        this.getTopicBlurb(topic);
    }

    get_wikipedia_link (topic) {
        let wp_url = '';
        if (typeof topic === 'object') {
            if ('wp_key' in topic) {
                wp_url += 'http://en.wikipedia.org/wiki/index.html?curid=';
                wp_url += topic['wp_key'];                
            }
        } 
        return wp_url;
    };


    nextPage  () {
        // Reset blurb to top of summary
        let blurb_el = document.getElementById(this.state.topic.id+'blurb_wrapper');
        if (blurb_el) {blurb_el.scrollTop = 0}
        this.getTopics(this.state.pg+1);
    }


    previousPage  () {
        this.getTopics(this.state.pg-1);
        // Reset blurb to top of summary
        let blurb_el = document.getElementById(this.state.topic.id+'blurb_wrapper');
        if (blurb_el) {blurb_el.scrollTop = 0}
    }

    cardNav () {
        // Navigation to next set if in group display or next topic if in single display
        
        const card = this.state;
        let next_button, previous_button = '';
        let last_on_pg = card.pg * card.pgsize;
        let first_on_pg = last_on_pg - (card.pgsize-1);

        if (first_on_pg !== 1) {
            previous_button =                 
                <div className='card_nav_cell'> 
                    <input type="image" title="previous" 
                        className="card_nav_button"  src={left_arrow}
                        onClick={this.previousPage}
                        alt="prev"
                        />
                   
                </div>
                ;	
        }

        if (last_on_pg > card.total) {
            last_on_pg = card.total;
        }
        if (last_on_pg < card.total) {
            next_button = 
            <div className='card_nav_cell'> 
                <input type="image" title="next" 
                    className="card_nav_button" src={right_arrow}
                    onClick={this.nextPage}
                    alt="next"
                    />
            </div>
            ;            
        }

        let page = (first_on_pg === last_on_pg) ? first_on_pg : 
                `${first_on_pg} to ${last_on_pg}`;

        // Display the button to switch back to group view if in single view
        let view_list = this.state.display === 'group' ? '' :
            <div className='card_nav_cell'> 
                <input type="image" title="list" 
                    className="card_nav_view_button" 
                    src={list_view_button}
                    onClick = {this.handleGroupDisplayClick}
                    alt="group view"
                />
            </div>;

        return (
            <div className='card_nav'>
                {previous_button}
                <div className='card_nav_pg_count '> {page} of {card.total}</div>
                {next_button}
                {view_list}
            </div>
        
        )

    }

    handlePageDown () {
        let blurb_el = document.getElementById(this.state.topic.id+'blurb_wrapper');
        let height = blurb_el.clientHeight;
        blurb_el.scrollTop = blurb_el.scrollTop+height;
    }

    handlePageUp () {
        let blurb_el = document.getElementById(this.state.topic.id+'blurb_wrapper');
        let height = blurb_el.clientHeight;
        blurb_el.scrollTop = blurb_el.scrollTop-height;
    }


    displaySingle () {
       if (Object.keys(this.state.topic).length === 0) {
            return;
        }

       let image_url = '';
       let topic = this.state.topic;
       if (topic.id in this.state.image_urls) {
           image_url = this.state.image_urls[topic.id]
       }

       let image_element = <img alt='.' className='detail_image' src={image_url}/>;
       if (image_url === '' || image_url === 'none') {
           image_element = <div className='detail_image'></div>;
       }
       
       const d = new Date(topic.property.day) 

       let card_info =
            <div className="detail_header">
                {image_element}
                <div className="detail_text">
                    <div className="detail_name">
                        <a href={`${this.get_wikipedia_link(topic)}`} 
                        className='single_name'
                        title='Go to Wikipedia page'
                        >{topic.name} </a>
                    </div>
                    <div className="detail_year">
                    {d.getFullYear()}
                    <span className="detail_attribute">{topic.property.name}</span>
                    </div>
                </div>
            </div>
            ;

        // TBD: refactor: slider is probably not necessary
       let blurb_wrapper_id = ''+topic.id+'blurb_wrapper';
       let blurb_slider_id = ''+topic.id+'blurb_slider';
       let blurb_id = ''+topic.id+'blurb';
       let blurb = '';
       if (topic.id in this.state.blurbs && 'text' in this.state.blurbs[topic.id]) {
            blurb = this.state.blurbs[topic.id].text;
       } 

        let blurb_section = 
            <>
            <div  id={blurb_wrapper_id} className="blurb_wrapper">
                <div id={blurb_slider_id} className="blurb_slider" > 
                    <div id={blurb_id} className="detail_blurb">{blurb}</div>
                </div>
            </div>
            </>
            ;


        let blurb_el = document.getElementById(this.state.topic.id+'blurb_wrapper');
        // On first render, the  wrapper doesn't exist, blurb_el invalid
        // Display down link and grayed up
        let scroll_down = 
            <>
            <a href="#0"  id='blurb_scroll_down' className="blurb_scroll_nav"
                onClick={this.handlePageDown}
                >Down
            </a>
            </>
            ;
        if (blurb_el &&
                blurb_el.scrollTop === blurb_el.scrollHeight-blurb_el.clientHeight) {
            scroll_down = <><span className="blurb_scroll_nav grayed"> Down</span></>;;
        }

        let scroll_up = 
            <>
            <a href="#0" id='blurb_scroll_up' className="blurb_scroll_nav"
            onClick={this.handlePageUp}
            > Up
            </a>
            </>  
            ;
        if (blurb_el && blurb_el.scrollTop === 0) {
            scroll_up = <><span className="blurb_scroll_nav grayed"> Up</span></>;
        }
    
        let blurb_scroll = 
            <>
            <div className="blurb_scroll_wrapper">
            {scroll_up}
            {scroll_down}
            </div>        
            </>
            
            ;

        return (
            <>
            {card_info}
            {blurb_section}
            {blurb_scroll}
            </>
        )
    } //displaySingle

    displayGroup = () => {
        
        if (Object.keys(this.state.topics).length === 0) {
            return;
        }

        const topiclines = this.state.topics.map ( (t,i) => {
            let image_url = '';
            if (t.id in this.state.image_urls) {
                image_url = this.state.image_urls[t.id]
            }

            return (
                <GroupCardTopic key={t.id} topic={t} 
                    image_url={image_url} 
                    handleGroupLineNameClick={this.handleGroupLineNameClick}                        
                />
               )
        })

        return topiclines;

    } //displayGroup


    render () {
        let display = (this.state.display === 'group') ?
            this.displayGroup() : this.displaySingle();
        let card =
            <div className='card'>    
                {this.props.title}
                {this.cardNav()} 
                {display}                
            </div>;

        return (
            <>
            {card}
            </>
            );
    }
}


export default Card;